import { initializeApp } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { getFirestore, collection, query, where, getDocs, doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: "extension-store-a9909.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Admin credentials
export const ADMIN_EMAIL = import.meta.env.VITE_ADMIN_EMAIL;
export const ADMIN_PASSWORD = import.meta.env.VITE_ADMIN_PASSWORD;

// Initialize collections
export const usersCollection = collection(db, 'users');
export const extensionsCollection = collection(db, 'extensions');
export const reviewsCollection = collection(db, 'reviews');
export const reportedReviewsCollection = collection(db, 'reportedReviews');
export const adminNotificationsCollection = collection(db, 'adminNotifications');

// Create admin user function
export const createAdminUser = async () => {
  try {
    // First check if admin exists in Firestore by querying users collection
    const usersRef = collection(db, 'users');
    const adminQuery = query(usersRef, where('email', '==', ADMIN_EMAIL));
    const adminSnapshot = await getDocs(adminQuery);

    if (!adminSnapshot.empty) {
      return; // Admin already exists in Firestore
    }

    // Try to sign in as admin first to check if exists in Auth
    try {
      const adminCredential = await signInWithEmailAndPassword(auth, ADMIN_EMAIL, ADMIN_PASSWORD);
      // If successful, just create the Firestore document
      await setDoc(doc(db, 'users', adminCredential.user.uid), {
        uid: adminCredential.user.uid,
        email: ADMIN_EMAIL,
        displayName: 'Admin',
        role: 'admin',
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });
    } catch (error: any) {
      // If admin doesn't exist in Auth, create new account
      if (error.code === 'auth/user-not-found') {
        const newAdminCredential = await createUserWithEmailAndPassword(
          auth,
          ADMIN_EMAIL,
          ADMIN_PASSWORD
        );

        await setDoc(doc(db, 'users', newAdminCredential.user.uid), {
          uid: newAdminCredential.user.uid,
          email: ADMIN_EMAIL,
          displayName: 'Admin',
          role: 'admin',
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        });
      } else {
        throw error; // Re-throw other errors
      }
    }
  } catch (error: any) {
    console.error('Error creating admin:', error);
  }
};